import React, { useState } from 'react'
import { Typography, Divider } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux';
import { useStyles, 
    Accordion, 
    AccordionSummary,
    AccordionDetails, DropzoneAreaCustom
} from './BrowserStyle'
import SimpleBarReact from "simplebar-react";
import 'simplebar/dist/simplebar.min.css';
import { setComplete, setHabilitado, setUpload } from '../../redux/actions/preguntaActions';
import { setExisteObservacion } from '../../redux/actions/estudianteActions';
import { DisabledControl } from './controles/Disabled';
import { RadioGroupControl } from './controles/RadioGroup';
import { CheckboxGroupControl } from './controles/CheckboxGroup';
import { SelectControl } from './controles/Select';
import { TextboxControl } from './controles/Textbox';
import { ComboCheckboxControl } from './controles/ComboCheckbox';
import { AvatarControl } from './controles/Avatar';
import { isBrowser } from "react-device-detect";
import { DropzoneArea } from 'material-ui-dropzone';
import AttachmentOutlinedIcon from '@material-ui/icons/AttachmentOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Chip from '@material-ui/core/Chip';
import ImageDialog from './controles/DialogImage';
import { LocationControl } from './controles/Location';
import { LocationsControl } from './controles/Locations';
import { Alert } from '@material-ui/lab';
import { FlashOnRounded } from '@material-ui/icons';

export const BrowserScreen = () => {
    const classes = useStyles()
    const dispatch = useDispatch()

  

    let { grupos, preguntas, respuestas, dependencias, excluyentes, archivos_pregunta, archivos_respuesta } = useSelector( state => state.pregunta )
    const [value, setValue] = useState(null);
    const informacion_basica = useSelector( state => state.informacion_basica )

    let habilita = 0;
    let listaDependencias = [];
    let listaRespuestas = [];
    let listaExcluyentes = [];
    let habilitarPreguntas = [];
    let RptasPreguntaSelected = [];
    
    let rptGrupo2 = "";


    
    const estudiante = useSelector( state => state.estudiante )
    const instituciones = useSelector( state => state.instituciones )
    const veeduria = useSelector( state => state.veeduria )





    const handleChange = (event, preguntaId, coordenadas = []) => {
        let cantRespuestasVacias = 0;
        let cantArchivosVacios = 0;
        let idRespuesta = '';

        //  alert( event.target.value)     
       
        console.log("preguntaId " + preguntaId);
        console.log(event);
        console.log("coordenadas " + coordenadas);

        preguntas.forEach(preg => {
            
           
            if ( preg.ID === preguntaId )
            {
              // alert(preg.DESCRIPCION)
              // alert('ingresa')
              // alert(preg.TIPO_RPTA_COD)
              // alert('sale')
                switch (preg.TIPO_RPTA_COD) {
                    case 1:
                //         alert('ingresa 001')
                //         event.target.show = false
                    case 3:
                        // RADIOBUTTON
                        // SELECT
                        // setValue({ ...value, [event.target.value]: event.target.value });
                        
                        //event.target.show = false
                        //alert('antes de rpta 0')
                        //alert(event.target.HABILITADO)
                        //alert(event.target.checked)
                        //alert('luego de rpta 0')

                        //alert('antes de rpta 1')
                        //alert(event.target.value)
                        //alert('luego de rpta 1')
                         idRespuesta = event.target.value.split('_')[1]
                        //alert('antes de rpta 2')
                        //alert(idRespuesta);
                        // alert('despues de rpta 2')
                        preg.RESPUESTA = []
                        preg.RESPUESTA.push( idRespuesta )

                        //alert(preg.RESPUESTA.DESCRIPCION)

                        showUpload(preg, idRespuesta, true, 'radio')
                        setDependencias( preg, idRespuesta )
                        break;

                    case 2:
                        // CHECKBOX
                        // setValue({ ...value, [event.target.name]: event.target.value });
                        // alert(preg.ID);
                        setValue({ ...value, [event.target.name]: event.target.name });
                        
                        idRespuesta = event.target.name.split('_')[1]

                        // agregado 04.05.2026

                        

                        // fin de agregado 04.05.2026

                        if ( event.target.checked )
                        {
                            setExcluyentes( preg, idRespuesta );
                            preg.RESPUESTA.push( idRespuesta )
                          /*  alert(10);
                           

                            switch ( idRespuesta ) {
                                    case 2398:

                                    alert(idRespuesta);

                                    habilitarPreguntas = preguntas.filter( e => e.ID == '844' );        // Pregunta 6
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = false;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                    });

                                    break;

                            }

*/
                        }
                        else {
                            preg.RESPUESTA = preg.RESPUESTA.filter( id => id !== idRespuesta )
                          //  alert(0);
                          //  alert(idRespuesta);
                        }

                        showUpload( preg, idRespuesta, event.target.checked, 'check' )
                        setDependencias( preg, idRespuesta, event.target.checked, 'check' )
                        break;

                    case 4:
                    case 7:
                        // TEXTBOX
                        setValue({ ...value, [event.target.name]: event.target.value });
                        
                        preg.RESPUESTA = []
                        if (event.target.value !== '')
                            preg.RESPUESTA.push( event.target.value )

                        idRespuesta = respuestas.filter(e => e.ID_PREGUNTA === preg.ID).length;

                        if (idRespuesta != 0)
                            idRespuesta = respuestas.filter(e => e.ID_PREGUNTA === preg.ID)[0].ID.toString();

                        showUpload( preg, idRespuesta, (event.target.value.toString().trim() == '' ? false : true), 'textbox' )
                        break;

                    case 5:
                    case 6:
                        // COMBOCHECKBOX
                        setValue({ ...value, [event.target.value]: event.target.value });
                        // let values = []
                        // event.target.value.forEach(element => {
                        //     values.push( element.split('_')[1]  )
                        // });
                        preg.RESPUESTA = event.target.value

                        // setDependencias(preg, event.target.value.split('_')[1]);
                        break;

                    case 8:
                    case 9:
                        // LOCATION
                        preg.RESPUESTA.push({coordenada: 'coordenada'})
                        console.log('coordenadas:::', coordenadas)
                        preg.COORDENADAS = coordenadas
                        break;
                
                    default:
                        break;
                }
            }
         
            if (preg.RESPUESTA.length === 0 && preg.IND_PADRE.toString() === '0' && preg.HABILITADO)
            {
                cantRespuestasVacias++;
            }

            if (preg.ARCHIVO.length === 0 && preg.OBLIGATORIO_ARCHIVO === '1' && preg.UPLOAD)
            {
                cantArchivosVacios++;
            }
        });

        existeObservacion()
        dispatch( setComplete( { isComplete: ( cantRespuestasVacias === 0 && cantArchivosVacios === 0 ) } ) )
    };
    
    // const handleReferenciaChange = (event, preguntaId, coordenadas = []) => {
    //     console.log('event:::', coordenadas)
    //     let cantRespuestasVacias = 0;
    //     let cantArchivosVacios = 0;
    //     let idRespuesta = '';
        
    //     console.log('event:::', event.target.value)
    //     if (coordenadas.length > 0)
    //         console.log('coordenadas:::', coordenadas.id)
    //     preguntas.forEach(preg => {
    //         if ( preg.ID === preguntaId )
    //         {
    //             // TEXTBOX
    //             setValue({ ...value, [event.target.name]: event.target.value });
                
    //             preg.RESPUESTA = []
    //             if (event.target.value != '')
    //                 preg.RESPUESTA.push( event.target.value )

    //             idRespuesta = respuestas.filter(e => e.ID_PREGUNTA === preg.ID).length;

    //             if (idRespuesta != 0)
    //                 idRespuesta = respuestas.filter(e => e.ID_PREGUNTA === preg.ID)[0].ID.toString();

    //             showUpload( preg, idRespuesta, (event.target.value.toString().trim() == '' ? false : true), 'textbox' )
    //         }

    //         if (preg.RESPUESTA.length === 0 && preg.IND_PADRE.toString() === '0' && preg.HABILITADO)
    //         {
    //             cantRespuestasVacias++;
    //         }

    //         if (preg.ARCHIVO.length === 0 && preg.OBLIGATORIO_ARCHIVO === '1' && preg.UPLOAD)
    //         {
    //             cantArchivosVacios++;
    //         }
    //     });

    //     existeObservacion()
    //     dispatch( setComplete( { isComplete: ( cantRespuestasVacias === 0 && cantArchivosVacios === 0 ) } ) )
    // };

    const setArchivo = (files, preguntaId) => {
        preguntas.forEach(preg => {
            if ( preg.ID === preguntaId )
            {
                preg.ARCHIVO = []
                files.forEach(file => {
                    getBase64(preg, file);
                });
            }
        });

    };

    const getBase64 = ( pregunta, file ) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            pregunta.ARCHIVO.push( {
                NOMBRE: file.name,
                BASE64: reader.result,
                EXTENSION: file.type,
            } );

            let cantRespuestasVacias = 0;
            let cantArchivosVacios = 0;
            
            preguntas.forEach(preg => {
                if (preg.RESPUESTA.length === 0 && preg.IND_PADRE.toString() === '0' && preg.HABILITADO)
                {
                    cantRespuestasVacias++;
                }
                if (preg.ARCHIVO.length === 0 && preg.OBLIGATORIO_ARCHIVO === '1' && preg.UPLOAD)
                {
                    cantArchivosVacios++;
                }
            });

            dispatch( setComplete({ isComplete: (cantRespuestasVacias === 0 && cantArchivosVacios === 0) }) );

        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const showUpload = (preg, valor, selected = true, tipoControl) => {
        if (valor !== undefined) {
            listaRespuestas = respuestas.filter(e => e.ID_PREGUNTA === preg.ID);
            
            if (listaRespuestas.length > 0)
            {
                let respuesta = listaRespuestas.filter(e => e.ID.toString() === valor)[0];

                let texto = '';
                switch (respuesta.FORMATO_ARCHIVO) {
                    case 'image/*':
                        texto = 'Opcional seleccione una imagen tipo PNG, JPG de un tamaño máximo de 30 MB';
                        break;
                    case 'video/*':
                        texto = 'Opcional seleccione un video';
                        break;
                    case 'image/*,video/*':
                        texto = 'Si tienes foto o video súbela aquí. (OPCIONAL)';
                        break;
                    default:
                        texto = 'Opcional seleccione un archivo';
                        break;
                }

                let show = false;
                if(tipoControl === 'check')
                {
                    let respuestasPreg = preguntas.filter(e => e.ID === preg.ID)[0].RESPUESTA;

                    if (respuesta.INDICADOR_ARCHIVO === '1')
                        show = (respuestasPreg.length != 0)

                    // let respuestasPreg = preguntas.filter(e => e.ID === preg.ID)[0].RESPUESTA;
                    // let desconozco = respuestasPreg.filter(e => e === '161').length;

                    // if (desconozco !== 1)
                    //     show = (respuestasPreg.length > 0);
                }
                // UPLOAD: selected ? (respuesta.INDICADOR_ARCHIVO === '1') : false,


                if(tipoControl === 'textbox')
                {
                    dispatch( setUpload({ ID: respuesta.ID_PREGUNTA,
                        UPLOAD: selected ? (respuesta.INDICADOR_ARCHIVO === '1') : false,
                        CANTIDAD_ARCHIVO: respuesta.CANTIDAD_ARCHIVO,
                        FORMATO_ARCHIVO: respuesta.FORMATO_ARCHIVO,
                        OBLIGATORIO_ARCHIVO: respuesta.OBLIGATORIO_ARCHIVO,
                        DROPZONE_TEXT: texto } ) )
                }
                else {
                    dispatch( setUpload({ ID: respuesta.ID_PREGUNTA,
                        UPLOAD: selected ? (respuesta.INDICADOR_ARCHIVO === '1') : (tipoControl === 'radio' ? false : show),
                        CANTIDAD_ARCHIVO: respuesta.CANTIDAD_ARCHIVO,
                        FORMATO_ARCHIVO: respuesta.FORMATO_ARCHIVO,
                        OBLIGATORIO_ARCHIVO: respuesta.OBLIGATORIO_ARCHIVO,
                        DROPZONE_TEXT: texto } ) )
                }
            }
        }
    }

 
    const setDependencias = (preg, valor, selected, tipoControl) => {

    /*   alert(tipoControl);
        alert(preg.ID.toString());
        alert(valor.toString());
        alert('2.0');*/
      

        if(tipoControl === 'check') {

          

                switch (preg.ID.toString()) {

                


                             /* */
                    

                    case '935':  // Pregunta 1

                    if ((valor.toString() == '2725') ){
                           
                        if (selected == true){
                            habilitarPreguntas = preguntas.filter( e => e.ID == '936' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                      
                        }
                        
                    }

                    if (valor.toString() == '2726'){

                           
                        if (selected == true){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '936' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });

                     
                        }
                       
               

                        if (selected == false){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '879' );        // Pregunta 4
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });

                        

                        }

                             }





                     

                    if ((valor.toString() == '2508') || (valor.toString() == '2509') || (valor.toString() == '2510')){
                           
                        if (selected == true){
                            habilitarPreguntas = preguntas.filter( e => e.ID == '860' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                            habilitarPreguntas = preguntas.filter( e => e.ID == '861' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                        }

                        
                    }



                        if (valor.toString() == '2511'){

                           
                            if (selected == true){

                                habilitarPreguntas = preguntas.filter( e => e.ID == '860' );        // Pregunta 11
                                habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });

                                habilitarPreguntas = preguntas.filter( e => e.ID == '861' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });

                            }
                           
                   

                            if (selected == false){

                                habilitarPreguntas = preguntas.filter( e => e.ID == '860' );        // Pregunta 11
                                habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });

                                habilitarPreguntas = preguntas.filter( e => e.ID == '861' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });

                            }

                                 }
                            break;

                }

           

           

                
            switch (preg.ID.toString()) {


                    




                case '575':
                    let pregunta = '';
                    switch (valor.toString()) {
                        case '1605':
                            pregunta = '576';
                            break;
                        case '1606':
                            pregunta = '577';
                            break;
                        case '1607':
                            pregunta = '578';
                            break;
                        case '1608':
                            pregunta = '579';
                            break;
                        case '1609':
                            pregunta = '580';
                            break;
                        case '1610':
                            pregunta = '581';
                            break;
                        case '1611':
                            pregunta = '582';
                            break;
                        case '1612':
                            pregunta = '583';
                            break;
                    }

                    habilitarPreguntas = preguntas.filter( e => e.ID == pregunta );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = selected;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: selected, UPLOAD: false }) )
                    })
                    break;
                    
                default:
                    let activa = false;

                    preg.RESPUESTA.forEach( r => {
                        listaDependencias = dependencias.filter(e => e.ID_PREGUNTA_PADRE == preg.ID && e.ID_RESPUESTA == r)
                        if (listaDependencias.length > 0) {
                            activa = true;
                            listaDependencias.forEach( d => {
                                habilitarPreguntas = preguntas.filter( e => e.ID == d.ID_PREGUNTA );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            })
                        }
                    });
                    
                    if (!activa) {
                        listaDependencias = dependencias.filter(e => e.ID_PREGUNTA_PADRE == preg.ID)
                        listaDependencias.forEach( d => {
                            habilitarPreguntas = preguntas.filter( e => e.ID == d.ID_PREGUNTA );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            })
                        })
                    }

                    break;
            }





        }
        else {

         //   checked= false

            

              //  alert('else1.0');
                //alert(preg.ID.toString());
                //alert(valor.toString() ); 
               //alert(index);

                console.log('preg.ID.toString() ' + preg.ID.toString() )
                console.log('rpta.ID ' + valor.toString() )

            // inicio rvelasquez 01082025
            switch (preg.ID.toString()) {


                case '955':     // Pregunta 10 SI

                 if ((valor.toString() == '2781') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '956' );        // Pregunta 11
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '957' );        // Pregunta 12
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });   

                    habilitarPreguntas = preguntas.filter( e => e.ID == '958' );        // Pregunta 13
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });  
                }

                if ((valor.toString() == '2782') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '956' );        // Pregunta 11
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '957' );        // Pregunta 12
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });   

                    habilitarPreguntas = preguntas.filter( e => e.ID == '958' );        // Pregunta 13
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });  
                }


                case '951':     // Pregunta 6 SI

                 if ((valor.toString() == '2771') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '952' );        // Pregunta 7
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '954' );        // Pregunta 9
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });   
                    
                      
                }

                 if ((valor.toString() == '2772') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '952' );        // Pregunta 7
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '954' );        // Pregunta 9
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });   
                    
                      
                }



                case '946':     // Pregunta 1 SI

                 if ((valor.toString() == '2749') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '947' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '948' );        // Pregunta 3
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });   
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '949' );        // Pregunta 4
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });  
                }


                if ((valor.toString() == '2750') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '947' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });    
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '948' );        // Pregunta 3
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });   
                    
                       habilitarPreguntas = preguntas.filter( e => e.ID == '949' );        // Pregunta 4
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });  
                }




                 if ((valor.toString() == '2726') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '936' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });     
                    
                 
                    
                }
                    
               




                case '937':     // Pregunta 5

                 if ((valor.toString() == '2729') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '938' );        // Pregunta 6
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });                 
                    
                }


                 if ((valor.toString() == '2730') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '938' );        // Pregunta 6
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });                 
                    
                }


                case '940':     // Pregunta 6

                 if ((valor.toString() == '2737') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '941' );        // Pregunta 7
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });                 
                    
                }


                 if ((valor.toString() == '2738') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '941' );        // Pregunta 7
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });                 
                    
                }

                case '942':     // Pregunta 8

                 if ((valor.toString() == '2741') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '943' );        // Pregunta 9
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });                 
                    
                }


                 if ((valor.toString() == '2742') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '943' );        // Pregunta 9
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });                 
                    
                }


                case '944':     // Pregunta 10

                 if ((valor.toString() == '2745') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '945' );        // Pregunta 11
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });                 
                    
                }


                 if ((valor.toString() == '2746') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '945' );        // Pregunta 11
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });                 
                    
                }



                case '907':

                if ((valor.toString() == '2645') ){

                        habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });

                     habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });
                                            
                    
                }

                if (valor.toString() == '2646'){
                    
                        habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });

                     habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                        habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });



                            }


                case '921':

                    if ((valor.toString() == '2680') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '922' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2681'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '922' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }


                case '915':

                    if ((valor.toString() == '2663') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '916' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2664'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '916' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }



                 case '911':

                    if ((valor.toString() == '2654') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '912' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2655'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '912' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }


                 case '908':

                    if ((valor.toString() == '2647') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2648'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }




                 case '906':

                    if ((valor.toString() == '2643') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });

                        habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2644'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });

                         habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }

                 case '905':

                    if ((valor.toString() == '2641') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '906' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });

                        habilitarPreguntas = preguntas.filter( e => e.ID == '907' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });

                        habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });

                        habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2642'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '906' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )

                        });
                           
                            habilitarPreguntas = preguntas.filter( e => e.ID == '907' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )

                        });

                         habilitarPreguntas = preguntas.filter( e => e.ID == '908' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )

                        });

                         habilitarPreguntas = preguntas.filter( e => e.ID == '909' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )

                        });


                             }






                  case '902':

                    if ((valor.toString() == '2635') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '903' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2636'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '903' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }


                  case '900':

                    if ((valor.toString() == '2630') ){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '901' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2631'){
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '901' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }


                  case '889':


                    if ((valor.toString() == '2601') ){
                           

                           console.log('valor.toString() dentro 1', valor.toString() )
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '890' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2602'){

                            console.log('valor.toString() dentro 2', valor.toString() )
                            habilitarPreguntas = preguntas.filter( e => e.ID == '890' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }
                 
                 case '886':

                    if ((valor.toString() == '2590') ){
                           
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                                              
                        
                    }

                    if (valor.toString() == '2591'){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }

                 case '876':

                    if ((valor.toString() == '2556') || (valor.toString() == '2557') || (valor.toString() == '2558')){
                           
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '877' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                      
                        
                        
                    }

                    if (valor.toString() == '2559'){

                           
                    

                            habilitarPreguntas = preguntas.filter( e => e.ID == '877' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }

                 case '878':

                    if ((valor.toString() == '2566') || (valor.toString() == '2567') || (valor.toString() == '2568')){
                           
                        
                            habilitarPreguntas = preguntas.filter( e => e.ID == '879' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        });
                      
                        
                        
                    }

                    if (valor.toString() == '2569'){

                            habilitarPreguntas = preguntas.filter( e => e.ID == '879' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        });



                             }

                    

               }  // fin rvelasquez 01082025
            
            switch (valor.toString()) {


                



                case '2626':     // Pregunta 7

                for (let index = 899; index <= 899; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    })
                }

                habilitarPreguntas = preguntas.filter( e => e.ID == '899' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = true;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                });

                
                break;

                case '2627':     // Pregunta 7

                for (let index = 899; index <= 899; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    })
                }

                

                habilitarPreguntas = preguntas.filter( e => e.ID == '899' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                break;


                case '2591':     // Pregunta 7

                for (let index = 887; index <= 887; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    })
                }

                habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                break;


                case '2591':     // Pregunta 7

                for (let index = 887; index <= 887; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    })
                }

                habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '887' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                break;






                case '2580':     // Pregunta 7

                for (let index = 883; index <= 884; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    })
                }

                habilitarPreguntas = preguntas.filter( e => e.ID == '883' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = true;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '884' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = true;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                });

                break;

                case '2581':     // Pregunta 7

                for (let index = 883; index <= 884; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    })
                }

                habilitarPreguntas = preguntas.filter( e => e.ID == '883' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '884' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                break;

               /* case '2580':        // 'a) Materiales físicos 
      
                for (let index = 883; index <= 884; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    })
                }

        
                
                habilitarPreguntas = preguntas.filter( e => e.ID == '883' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = true;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '884' );        // Pregunta 11
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = true;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                });
              

              break;*/

            /*  case '2581':        // 'a) Materiales físicos 
      
                for (let index = 883; index <= 884; index++) {        // 
                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    })
                }

        
                
                habilitarPreguntas = preguntas.filter( e => e.ID == '883' );        // Pregunta 8
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });

                habilitarPreguntas = preguntas.filter( e => e.ID == '884' );        // Pregunta 9
                habilitarPreguntas.forEach( e => {
                    e.RESPUESTA = [];
                    e.HABILITADO = false;
                    e.UPLOAD = false;
                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                });
              

              break;*/


                




                case '857':     // Pregunta 3
                switch (valor.toString()) {
                    case '2503':        // 'a) Materiales digitales 
      
                    for (let index = 858; index <= 858; index++) {        // 
                        habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                        habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        })
                    }

            
                    
                    habilitarPreguntas = preguntas.filter( e => e.ID == '858' );        // Pregunta 11
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = false;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                    });
                  
                    // localStorage.getItem('saj_nivel') == 'P'

                  break;

                  case '2502':        // 'a) Materiales físicos 
      
                    for (let index = 858; index <= 858; index++) {        // 
                        habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                        habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = true;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                        })
                    }

            
                    
                    habilitarPreguntas = preguntas.filter( e => e.ID == '858' );        // Pregunta 11
                    habilitarPreguntas.forEach( e => {
                        e.RESPUESTA = [];
                        e.HABILITADO = true;
                        e.UPLOAD = false;
                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                    });
                  

                  break;

                  case '2502':        // 'a) Materiales físicos
      
                  for (let index = 858; index <= 858; index++) {        // 
                      habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                      habilitarPreguntas.forEach( e => {
                          e.RESPUESTA = [];
                          e.HABILITADO = true;
                          e.UPLOAD = false;
                          dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                      })
                  }

          
                  
                  habilitarPreguntas = preguntas.filter( e => e.ID == '858' );        // Pregunta 11
                  habilitarPreguntas.forEach( e => {
                      e.RESPUESTA = [];
                      e.HABILITADO = true;
                      e.UPLOAD = false;
                      dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                  });
                
                  // localStorage.getItem('saj_nivel') == 'P'

                break;


                case '2504':        // 'c) Ambos
      
                  for (let index = 858; index <= 858; index++) {        // 
                      habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                      habilitarPreguntas.forEach( e => {
                          e.RESPUESTA = [];
                          e.HABILITADO = true;
                          e.UPLOAD = false;
                          dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                      })
                  }

          
                  
                  habilitarPreguntas = preguntas.filter( e => e.ID == '858' );        // Pregunta 11
                  habilitarPreguntas.forEach( e => {
                      e.RESPUESTA = [];
                      e.HABILITADO = true;
                      e.UPLOAD = false;
                      dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                  });
                
                  // localStorage.getItem('saj_nivel') == 'P'

                break;


                }

                 break;
                   

                
                    switch (valor.toString()) {
                        case '2379':        // SI

                     //   alert(target.value)

                            for (let index = 839; index <= 841; index++) {        // Pregunta 2
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '839' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '840' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            habilitarPreguntas = preguntas.filter( e => e.ID == '841' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            habilitarPreguntas = preguntas.filter( e => e.ID == '854' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });                           

                            break;
                        
                        case '2380':        // SI

                            for (let index = 839; index <= 841; index++) {        // Pregunta 2
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '839' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '840' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            habilitarPreguntas = preguntas.filter( e => e.ID == '841' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            habilitarPreguntas = preguntas.filter( e => e.ID == '854' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            break;

                        


                        case '2381':        // NO

       
    
                                for (let index = 839; index <= 841; index++) {        // Pregunta 2
                                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = false;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                    })
                                }
    
                                habilitarPreguntas = preguntas.filter( e => e.ID == '839' );        // Pregunta 6
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
                                
                                habilitarPreguntas = preguntas.filter( e => e.ID == '840' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
                                habilitarPreguntas = preguntas.filter( e => e.ID == '841' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
                                habilitarPreguntas = preguntas.filter( e => e.ID == '854' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
    
                                break;



                        
                            
                        case '23811':         // NO
                        

                            habilitarPreguntas = preguntas.filter( e => e.ID == '829' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });


                            for (let index = 830; index <= 837; index++) {        // Pregunta 3
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '833' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            break;
                    }
                    break;

                case '930':     // Pregunta 5
                    switch (valor.toString()) {
                        case '2713':        // SI

                            for (let index = 931; index <= 931; index++) {        // Pregunta 6
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '931' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });


                            case '2714':        // NO

                            for (let index = 931; index <= 931; index++) {        // Pregunta 6
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '931' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            
                            
                      

                            break;
                       

                        case '2396':        // NO

                        

                            for (let index = 843; index <= 844; index++) {        // Pregunta 2
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '843' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '844' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });

                            habilitarPreguntas = preguntas.filter( e => e.ID == '845' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            // localStorage.getItem('saj_nivel') == 'P'

                            break;
                        }
                        break;


                        case '849':     // Pregunta 12
                        switch (valor.toString()) {
                            case '2481':        // SI
    
                                for (let index = 850; index <= 852; index++) {        // Pregunta 2
                                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = true;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                    })
                                }
    
                                habilitarPreguntas = preguntas.filter( e => e.ID == '850' );        // Pregunta 6
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                });
                                
                                habilitarPreguntas = preguntas.filter( e => e.ID == '851' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                });
                                
                                habilitarPreguntas = preguntas.filter( e => e.ID == '852' );        // Pregunta 6
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                });
                                
                                habilitarPreguntas = preguntas.filter( e => e.ID == '853' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                });
    
                                break;
                                case '2482':        // NO
                              
                                    for (let index = 850; index <= 853; index++) {        // Pregunta 12
                                        habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                        habilitarPreguntas.forEach( e => {
                                            e.RESPUESTA = [];
                                            e.HABILITADO = false;
                                            e.UPLOAD = false;
                                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                        })
                                    }
        
                                    habilitarPreguntas = preguntas.filter( e => e.ID == '850' );        // Pregunta 6
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = false;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                    });
                                    
                                    habilitarPreguntas = preguntas.filter( e => e.ID == '851' );        // Pregunta 7
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = true;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                    });
                                    
                                    habilitarPreguntas = preguntas.filter( e => e.ID == '852' );        // Pregunta 6
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = true;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                    });
                                    
                                    habilitarPreguntas = preguntas.filter( e => e.ID == '853' );        // Pregunta 7
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = true;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                    });
        
                                    break;
    
                            case '2396':        // NO
    
                            
    
                                for (let index = 843; index <= 844; index++) {        // Pregunta 2
                                    habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                    habilitarPreguntas.forEach( e => {
                                        e.RESPUESTA = [];
                                        e.HABILITADO = false;
                                        e.UPLOAD = false;
                                        dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                    })
                                }
    
                                habilitarPreguntas = preguntas.filter( e => e.ID == '843' );        // Pregunta 6
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
                                
                                habilitarPreguntas = preguntas.filter( e => e.ID == '844' );        // Pregunta 7
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                });
                                
                                // localStorage.getItem('saj_nivel') == 'P'
    
                                break;
                            }
                            break;

                case '828':     // Pregunta 1
                    switch (valor.toString()) {
                        case '2339':        // SI

                            // let respuesta2 = '';
                            // habilitarPreguntas = preguntas.filter( e => e.ID == '665' );     // Pregunta 2
                            // habilitarPreguntas.forEach( e => {
                            //     if(e.RESPUESTA.length != 0 )
                            //         respuesta2 = e.RESPUESTA[0] == '1884' ? 'SI' : 'NO';
                            // })


                            // habilitarPreguntas = preguntas.filter( e => e.ID == '666' );        // Pregunta 3 (La evaluada)
                            // habilitarPreguntas.forEach( e => {
                            //     e.RESPUESTA = [];
                            //     e.HABILITADO = (respuesta2 == 'SI') ? true : false;
                            //     e.UPLOAD = false;
                            //     dispatch( setHabilitado({ ID: e.ID, HABILITADO: (respuesta2 == 'SI') ? true : false, UPLOAD: false }) )
                            // })


                            for (let index = 829; index <= 837; index++) {        // Pregunta 2
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }

                            habilitarPreguntas = preguntas.filter( e => e.ID == '833' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            // localStorage.getItem('saj_nivel') == 'P'

                            break;
                            
                        case '2340':         // NO
                        

                            habilitarPreguntas = preguntas.filter( e => e.ID == '829' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });


                            for (let index = 830; index <= 837; index++) {        // Pregunta 3
                                habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = true;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                                })
                            }
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '833' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            // for (let index = 728; index <= 742; index++) {
                            //     habilitarPreguntas = preguntas.filter( e => e.ID == index.toString() );        // Pregunta 4
                            //     habilitarPreguntas.forEach( e => {
                            //         e.RESPUESTA = [];
                            //         e.HABILITADO = true;
                            //         e.UPLOAD = false;
                            //         dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            //     })
                            // }

                            
                            // ['730', '731', '734', '736', '740'].forEach(element => {
                            //     habilitarPreguntas = preguntas.filter( e => e.ID == element );        // Pregunta 8
                            //     habilitarPreguntas.forEach( e => {
                            //         e.RESPUESTA = [];
                            //         e.HABILITADO = false;
                            //         e.UPLOAD = false;
                            //         dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            //     })
                            // });
                            
                            break;
                    }
                    break;
                    
/*
                case '832':     // Pregunta 5
                    switch (valor.toString()) {
                        case '2352':        // SI
                            habilitarPreguntas = preguntas.filter( e => e.ID == '833' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            break;
                            
                        case '2353':         // NO
                            habilitarPreguntas = preguntas.filter( e => e.ID == '833' );        // Pregunta 6
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            break;
                    }
                    break;
   */                 

                case '833':     // Pregunta 6
                    switch (valor.toString()) {
                        case '2354':        // a
                        case '2355':        // b
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            });
                            break;
                            
                        case '2356':         // c
                            habilitarPreguntas = preguntas.filter( e => e.ID == '834' );        // Pregunta 7
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            });
                            break;
                    }
                    break;
                    





                case '818':     // Pregunta 1
                    switch (valor.toString()) {
                        case '2313':        // a) Al ingreso
                        case '2314':        // b) A la salida
                        case '2315':        // c) Ingreso y salida
                            habilitarPreguntas = preguntas.filter( e => e.ID == '819' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            })
                            break;
                            
                        case '2316':        // d) Nunca
                            habilitarPreguntas = preguntas.filter( e => e.ID == '819' );        // Pregunta 2
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            })
                            break;
                    }
                    break;
                    

                case '820':     // Pregunta 3
                    switch (valor.toString()) {
                        case '2319':        // a) Al ingreso
                        case '2320':        // b) A la salida
                        case '2321':        // c) Ingreso y salida
                            habilitarPreguntas = preguntas.filter( e => e.ID == '821' );        // Pregunta 4
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            })
                            break;
                            
                        case '2322':        // d) Nunca
                            habilitarPreguntas = preguntas.filter( e => e.ID == '821' );        // Pregunta 4
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            })
                            break;
                    }
                break;
                
                    


                case '654':
                    switch (valor.toString()) {
                        case '1856':
                            let respuesta6 = '';
                            habilitarPreguntas = preguntas.filter( e => e.ID == '653' );
                            habilitarPreguntas.forEach( e => {
                                if(e.RESPUESTA.length != 0 )
                                    respuesta6 = e.RESPUESTA[0] == '1854' ? 'SI' : 'NO';
                            })

                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '655' );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = true;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: true, UPLOAD: false }) )
                            })
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '656' );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = (respuesta6 == 'SI') ? true : false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: (respuesta6 == 'SI') ? true : false, UPLOAD: false }) )
                            })
                            break;
                            
                        case '1857':
                            habilitarPreguntas = preguntas.filter( e => e.ID == '655' );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            })
                            
                            habilitarPreguntas = preguntas.filter( e => e.ID == '656' );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                e.HABILITADO = false;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                            })
                            break;
                    }
                    break;
                    
                default:
                    listaDependencias = dependencias.filter(e => e.ID_PREGUNTA_PADRE == preg.ID && e.ID_RESPUESTA == valor)
                    if (listaDependencias.length > 0)
                    {
                        
                        listaDependencias.forEach( d => {
                            
                            RptasPreguntaSelected = preguntas.filter( e => e.ID == preg.ID );
                            let cantRptas = 0;
                            if (RptasPreguntaSelected.length != 0)
                                cantRptas = RptasPreguntaSelected[0].RESPUESTA.length;
            
                            habilitarPreguntas = preguntas.filter( e => e.ID == d.ID_PREGUNTA );
                            habilitarPreguntas.forEach( e => {
                                e.RESPUESTA = [];
                                let listaPadres = dependencias.filter(x => x.ID_PREGUNTA == e.ID)
                                let hab = true;
            
                                if (listaPadres.length > 1) {
                                    let esElMayor = true;
                                    listaPadres.forEach( y => {
                                        if( preg.ID < y.ID_PREGUNTA_PADRE )
                                            esElMayor = false
                                    })
            
                                    if ( !esElMayor && selected)
                                        hab = false;
                                    else
                                        hab = selected;
                                }
                                
                                e.HABILITADO = hab;
                                e.UPLOAD = false;
                                dispatch( setHabilitado({ ID: e.ID, HABILITADO: hab, UPLOAD: false }) )
                            })
            
                        })
                    }
                    else{
                        listaDependencias = dependencias.filter(e => e.ID_PREGUNTA_PADRE == preg.ID )
                        if (listaDependencias.length > 0)
                        {
                            listaDependencias.forEach( d => {
                                habilitarPreguntas = preguntas.filter( e => e.ID == d.ID_PREGUNTA );
                                habilitarPreguntas.forEach( e => {
                                    e.RESPUESTA = [];
                                    e.HABILITADO = false;
                                    e.UPLOAD = false;
                                    dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                                })
                
                            })
                        }
            
            
                    }

                    if( (informacion_basica.cargo == '004' || informacion_basica.cargo == '005' || informacion_basica.cargo == '006') ||
                    ((informacion_basica.miembro == '003') && (informacion_basica.cargo == '001' || informacion_basica.cargo == '002' || informacion_basica.cargo == '003')) ) {
                        habilitarPreguntas = preguntas.filter( e => e.ID == '510' );
                        habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        })
                    }
                    
                    if(informacion_basica.cargo == '003' || informacion_basica.cargo == '004' || informacion_basica.cargo == '005' || informacion_basica.cargo == '006') {
                        habilitarPreguntas = preguntas.filter( e => e.ID == '518' );
                        habilitarPreguntas.forEach( e => {
                            e.RESPUESTA = [];
                            e.HABILITADO = false;
                            e.UPLOAD = false;
                            dispatch( setHabilitado({ ID: e.ID, HABILITADO: false, UPLOAD: false }) )
                        })
                    }
                    break;
            }

            
        }

    }




    const setExcluyentes = (preg, valor) => {
        listaExcluyentes = excluyentes.filter(e => e.ID_PREGUNTA === preg.ID)
        if (listaExcluyentes.length > 0)
        {
            let tiene = listaExcluyentes.filter(e => e.ID_PREGUNTA === preg.ID)

            switch (valor) {
                case '1719':
                    const index = preg.RESPUESTA.indexOf('1663');
                    if (index != -1)
                        preg.RESPUESTA.splice(index, 1); 
                    
                    const index2 = preg.RESPUESTA.indexOf('1668');
                    if (index2 != -1)
                        preg.RESPUESTA.splice(index2, 1); 
                    
                    const indexX = preg.RESPUESTA.indexOf('1669');
                    if (indexX != -1)
                        preg.RESPUESTA.splice(indexX, 1);
                    break;

                case '1663':
                    const index3 = preg.RESPUESTA.indexOf('1719');
                    if (index3 != -1)
                        preg.RESPUESTA.splice(index3, 1);   
                    
                    const index4 = preg.RESPUESTA.indexOf('1668');
                    if (index4 != -1)
                        preg.RESPUESTA.splice(index4, 1);  
                    
                    const indexY = preg.RESPUESTA.indexOf('1669');
                    if (indexY != -1)
                        preg.RESPUESTA.splice(indexY, 1);         
                    break;

                case '1668':
                    const index5 = preg.RESPUESTA.indexOf('1719');
                    if (index5 != -1)
                        preg.RESPUESTA.splice(index5, 1); 
                    
                    const index6 = preg.RESPUESTA.indexOf('1663');
                    if (index6 != -1)
                        preg.RESPUESTA.splice(index6, 1);
                    
                    const indexZ = preg.RESPUESTA.indexOf('1669');
                    if (indexZ != -1)
                        preg.RESPUESTA.splice(indexZ, 1); 
                    break;
        
            
                default:
                    if ( tiene.length > 0 ) {
                        habilita = listaExcluyentes.filter(e => e.ID_RESPUESTA.toString() === valor).length
                        if (habilita === 1){
                            preg.RESPUESTA = [];
                        }
                        else
                        {
                            switch (tiene.length) {
                                case 1:
                                    preg.RESPUESTA = preg.RESPUESTA.filter( id => id !== tiene[0].ID_RESPUESTA.toString() )
                                    break;
        
                                case 2:
                                    preg.RESPUESTA = preg.RESPUESTA.filter( id => id !== tiene[0].ID_RESPUESTA.toString() && id !== tiene[1].ID_RESPUESTA.toString() )
                                    break;
                            }
                        }
                    }
                    break;
            }
        }
    }

    
    const existeObservacion = () => {
        let cantObservaciones = 0
        preguntas.forEach(preg => {
            if ( preg.TIPO_RPTA_COD !== 4 && preg.TIPO_RPTA_COD !== 7 ) {
               
                if ( !( preg.RESPUESTA.length === 0 && preg.IND_PADRE.toString() === '0' && preg.HABILITADO ) )
                {
                    listaRespuestas = respuestas.filter( e => e.ID_PREGUNTA === preg.ID );
                    if ( listaRespuestas.length > 0 )
                        preg.RESPUESTA.forEach( rpta => {
                            let respuesta = listaRespuestas.filter( e => e.ID.toString() === rpta )[0];
                           // let respuesta = '98';
                            if ( respuesta.OBSERVACION === '1' )
                                cantObservaciones++;
                        });
                }
            }
        });
        dispatch( setComplete( { existe_observacion: ( cantObservaciones === preguntas.length ) } ) );
        dispatch( setExisteObservacion( { existe_observacion: ( cantObservaciones === preguntas.length ) } ) );
    }


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 100,
            },
        },
    }


    const [isOpenImageDialog, setIsOpenImageDialog] = useState(false);
    const [filtroImageDialog, setFiltroImageDialog] = useState({ pregunta: 0, respuesta: 0 });
    const handleOpenImageDialog = ( objeto ) => {
        setIsOpenImageDialog(!isOpenImageDialog);
        setFiltroImageDialog(objeto);
    };



    return (
        <>
        {/* <SimpleBarReact style={{ maxHeight: 500 }} forceVisible="y" autoHide={ false }> */}
            <div className="ed-grid s-grid-1">
                {
                    grupos.map( grupo => (
                        <Accordion square expanded>
                            <AccordionSummary aria-controls="panel1d-content" id={ grupo.ID }>
                                <Typography>{ grupo.DESCRIPCION }</Typography>
                            </AccordionSummary>
                            {
                                preguntas.filter( preg => preg.GRUPO_COD === grupo.ID && preg.ID_PADRE === 0 )
                                .map( preg => (
                                    <>
                                    {
                                        ( preg.IND_PADRE === '0' )
                                        ?
                                            <AccordionDetails>
                                                <div className="ed-container full">
                                                    <div className="ed-item" style={ { padding: '0px' } }>
                                                        <div className="ed-grid s-grid-8 m-grid-12">
                                                            <div className={ classes.center_item }>
                                                                <AvatarControl clase={ 
                                                                    isBrowser 
                                                                    ? classes.largeBrowser 
                                                                    : classes.largeMobile }
                                                                    numero={ preg.CODIGO }
                                                                    sizeText={
                                                                        isBrowser 
                                                                        ? classes.textBrowser 
                                                                        : classes.textMobile }/>
                                                            </div>
                                                            <div className="s-cols-7 m-cols-11 ed-grid rows-gap">
                                                                <div className={ classes.center_item }>
                                                                    <div className={ isBrowser && classes.align_items_middle }>
                                                                        <Typography className={ classes.pregDesc }>{ preg.DESCRIPCION }</Typography>
                                                                        {
                                                                            preg.IND_IMAGEN != '0'
                                                                            &&
                                                                            <Chip
                                                                                icon={<InfoOutlinedIcon />}
                                                                                label="Imagen"
                                                                                clickable
                                                                                color="primary"
                                                                                variant="outlined"
                                                                                size="small"
                                                                                style={{ marginLeft: '10px'}}
                                                                                onClick={ () => handleOpenImageDialog( { pregunta: preg.ID, respuesta: 0 } ) }
                                                                            />
                                                                        }
                                                                    </div>
                                                                  <Typography className={ classes.pregNota }>{ preg.NOTA }</Typography> 
                                                                </div>
                                                                <div className={ classes.center_item }>
                                                                    {
                                                                        // RADIOBUTTON
                                                                        ( preg.TIPO_RPTA_COD === 1 )
                                                                        &&
                                                                        <>
                                                                            <div>
                                                                                {
                                                                                    // Radio butons - Pregunta 2
                                                                                    ( 1 == 5 )
                                                                                    ?
                                                                                    <
                                                                                         DisabledControl    
                                                                                    />
                                                                                    :
                                                                                    
                                                                                    ( preg.HABILITADO )
                                                                                    ?
                                                                                       <RadioGroupControl respuestas={ respuestas }
                                                                                        archivos_respuesta={ archivos_respuesta }
                                                                                        preg={ preg }
                                                                                        handleChange={ handleChange }
                                                                                        
                                                                                        />
                                                                                        
                                                                                    :
                                                                                        <DisabledControl/>
                                                                                        
                                                                                }
                                                                            </div>
                                                                            {
                                                                                ( preg.UPLOAD )
                                                                                &&
                                                                                <div>
                                                                                    <DropzoneAreaCustom
                                                                                    acceptedFiles={ [preg.FORMATO_ARCHIVO] }
                                                                                    // acceptedFiles={ ['image/jpeg', 'image/png', 'image/bmp'] }
                                                                                    // dropzoneClass={ classes.dropZone }
                                                                                    // previewGridClasses={{
                                                                                    //     item: classes.preview,
                                                                                    // }}
                                                                                    // getPreviewIcon={(file) => {
                                                                                    // if (file.file.type.split('/')[0] === 'image')
                                                                                    //     return (
                                                                                    //     <img className={classes.previewImg} role="presentation" src={file.data} />
                                                                                    //     );
                                                                                    // }}
                                                                                    maxFileSize={ 30000000 }
                                                                                    filesLimit={ preg.CANTIDAD_ARCHIVO }
                                                                                    dropzoneText={ preg.DROPZONE_TEXT }
                                                                                    getFileLimitExceedMessage={ (filesLimit) => { return `Se superó el número máximo permitido de archivos. Solo se permiten ${ filesLimit }.` } }
                                                                                    getFileAddedMessage={ (fileName) => { return `El archivo ${ fileName } se agregó correctamente.` } }
                                                                                    getFileRemovedMessage={ (fileName) => { return `Archivo ${ fileName } eliminado.` } }
                                                                                    getDropRejectMessage={ (rejectedFile, acceptedFiles, maxFileSize) => { return `El archivo ${ rejectedFile.name } fue rechazado. El tipo de archivo no es compatible. El archivo es demasiado grande. El límite de tamaño es ${ maxFileSize / 1000000 } megabytes.` } }
                                                                                    //onChange={ (files) => console.log('Files:', files) }
                                                                                    onChange={ ( files ) => setArchivo( files, preg.ID ) }
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        // CHECKBOX
                                                                        ( preg.TIPO_RPTA_COD === 2 )
                                                                        &&
                                                                        <>
                                                                            <div>
                                                                                {
                                                                                    ( preg.HABILITADO )
                                                                                    ?
                                                                                        <CheckboxGroupControl respuestas={ respuestas }
                                                                                        archivos_respuesta={ archivos_respuesta }
                                                                                        preg={ preg }
                                                                                        handleChange={ handleChange }/>
                                                                                    :
                                                                                        <DisabledControl/>
                                                                                }
                                                                            </div>
                                                                            {
                                                                                ( preg.UPLOAD )
                                                                                &&
                                                                                <div>
                                                                                    <DropzoneAreaCustom
                                                                                    acceptedFiles={ [preg.FORMATO_ARCHIVO] }
                                                                                    maxFileSize={ 30000000 }
                                                                                    filesLimit={ preg.CANTIDAD_ARCHIVO }
                                                                                    dropzoneText={ preg.DROPZONE_TEXT }
                                                                                    getFileLimitExceedMessage={ (filesLimit) => { return `Se superó el número máximo permitido de archivos. Solo se permiten ${ filesLimit }.` } }
                                                                                    getFileAddedMessage={ (fileName) => { return `El archivo ${ fileName } se agregó correctamente.` } }
                                                                                    getFileRemovedMessage={ (fileName) => { return `Archivo ${ fileName } eliminado.` } }
                                                                                    getDropRejectMessage={ (rejectedFile, acceptedFiles, maxFileSize) => { return `El archivo ${ rejectedFile.name } fue rechazado. El tipo de archivo no es compatible. El archivo es demasiado grande. El límite de tamaño es ${ maxFileSize / 1000000 } megabytes.` } }
                                                                                    //onChange={ (files) => console.log('Files:', files) }
                                                                                    onChange={ ( files ) => setArchivo( files, preg.ID ) }
                                                                                    
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        // SELECT
                                                                        ( preg.TIPO_RPTA_COD === 3 )
                                                                        &&
                                                                        <div>
                                                                            {
                                                                                ( preg.HABILITADO )
                                                                                ?
                                                                                    <SelectControl respuestas={ respuestas }
                                                                                    preg={ preg }
                                                                                    classes={ classes }
                                                                                    handleChange={ handleChange }/>
                                                                                :
                                                                                    <DisabledControl/>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        // TEXTBOX
                                                                        ( preg.TIPO_RPTA_COD === 4 || preg.TIPO_RPTA_COD === 7 )
                                                                        &&
                                                                        <>
                                                                            <div>
                                                                                {
                                                                                    ( preg.HABILITADO )
                                                                                    ?
                                                                                        <TextboxControl preg={ preg }
                                                                                        classes={ classes }
                                                                                        handleChange={ handleChange }/>
                                                                                    :
                                                                                        <DisabledControl/>
                                                                                }
                                                                            </div>
                                                                            {
                                                                                ( preg.UPLOAD && preg.RESPUESTA.length != 0 )
                                                                                &&
                                                                                <div>
                                                                                    <DropzoneAreaCustom
                                                                                    acceptedFiles={ [preg.FORMATO_ARCHIVO] }
                                                                                    maxFileSize={ 30000000 }
                                                                                    filesLimit={ preg.CANTIDAD_ARCHIVO }
                                                                                    dropzoneText={ preg.DROPZONE_TEXT }
                                                                                    getFileLimitExceedMessage={ (filesLimit) => { return `Se superó el número máximo permitido de archivos. Solo se permiten ${ filesLimit }.` } }
                                                                                    getFileAddedMessage={ (fileName) => { return `El archivo ${ fileName } se agregó correctamente.` } }
                                                                                    getFileRemovedMessage={ (fileName) => { return `Archivo ${ fileName } eliminado.` } }
                                                                                    getDropRejectMessage={ (rejectedFile, acceptedFiles, maxFileSize) => { return `El archivo ${ rejectedFile.name } fue rechazado. El tipo de archivo no es compatible. El archivo es demasiado grande. El límite de tamaño es ${ maxFileSize / 1000000 } megabytes.` } }
                                                                                    //onChange={ (files) => console.log('Files:', files) }
                                                                                    onChange={ ( files ) => setArchivo( files, preg.ID ) }
                                                                                    
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        // COMBOCHECKBOX
                                                                        ( preg.TIPO_RPTA_COD === 5 || preg.TIPO_RPTA_COD === 6 )
                                                                        &&
                                                                        <ComboCheckboxControl respuestas={ respuestas }
                                                                        preg={ preg }
                                                                        classes={ classes }
                                                                        MenuProps={ MenuProps }
                                                                        handleChange={ handleChange }/>
                                                                    }
                                                                    {
                                                                        // ONE LOCATION
                                                                        ( preg.TIPO_RPTA_COD === 8 )
                                                                        &&
                                                                        <div>
                                                                            {
                                                                                ( preg.HABILITADO )
                                                                                ?
                                                                                    <LocationControl preg={ preg }
                                                                                    classes={ classes }
                                                                                    handleGuardarCoordenada={ handleChange }
                                                                                    handleReferencia={ handleChange } />
                                                                                :
                                                                                    <DisabledControl/>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        // MANY LOCATIONS
                                                                        ( preg.TIPO_RPTA_COD === 9 )
                                                                        &&
                                                                        <div>
                                                                            {
                                                                                ( preg.HABILITADO )
                                                                                ?
                                                                                    <LocationControl preg={ preg }
                                                                                    classes={ classes }
                                                                                    handleGuardarCoordenada={ handleChange }
                                                                                    handleReferencia={ handleChange } />
                                                                                    // <LocationsControl preg={ preg }
                                                                                    // classes={ classes }
                                                                                    // handleGuardarCoordenada={ handleChange }
                                                                                    // handleReferencia={ handleChange } />
                                                                                :
                                                                                    <DisabledControl/>
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        :
                                            <AccordionDetails>
                                                <div className="ed-container full">
                                                    <div className="ed-item" style={ { padding: '0px' } }>
                                                        <div className="ed-grid s-grid-8 m-grid-12">
                                                            <div className={ classes.center_item }>
                                                                <AvatarControl clase={ 
                                                                    isBrowser 
                                                                    ? classes.largeBrowser 
                                                                    : classes.largeMobile } numero={ preg.CODIGO }
                                                                    sizeText={
                                                                        isBrowser 
                                                                        ? classes.textBrowser 
                                                                        : classes.textMobile }/>
                                                            </div>
                                                            <div className="s-cols-3 m-cols-4" style={ { margin: 'auto' } }>
                                                                <Typography>{ preg.DESCRIPCION }</Typography>
                                                                <Typography>{ preg.NOTA }</Typography>
                                                            </div>
                                                            <div className="s-cols-4 m-cols-6 ed-grid s-grid-4 m-grid-8 rows-gap">
                                                                {
                                                                    preguntas.filter( hijo => hijo.ID_PADRE === preg.ID )
                                                                    .map( (hijo, index) => (
                                                                        <>
                                                                            <div className={ classes.center_item }>
                                                                                <AvatarControl clase={ 
                                                                                    isBrowser 
                                                                                    ? classes.smallBrowser 
                                                                                    : classes.smallMobile } numero={ hijo.CODIGO }
                                                                                    sizeText={
                                                                                        isBrowser 
                                                                                        ? classes.textBrowser 
                                                                                        : classes.textMobile }/>
                                                                            </div>
                                                                            <div className="s-cols-3 m-cols-7 ed-grid rows-gap">
                                                                                <div className={ classes.center_item }>
                                                                                
                                                                                </div>
                                                                                <div className={ classes.center_item }>
                                                                                    {
                                                                                        // RADIOBUTTON
                                                                                        ( hijo.TIPO_RPTA_COD === 1 )
                                                                                        &&
                                                                                        <RadioGroupControl respuestas={ respuestas }
                                                                                        archivos_respuesta={ archivos_respuesta }
                                                                                        preg={ hijo }
                                                                                        handleChange={ handleChange }/>
                                                                                    }
                                                                                    {
                                                                                        // CHECKBOX
                                                                                        ( hijo.TIPO_RPTA_COD === 2 )
                                                                                        &&
                                                                                        <CheckboxGroupControl respuestas={ respuestas }
                                                                                        archivos_respuesta={ archivos_respuesta }
                                                                                        preg={ hijo }
                                                                                        handleChange={ handleChange }/>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                ( index < preguntas.filter( hijo => hijo.ID_PADRE === preg.ID ).length - 1 )
                                                                                &&
                                                                                <div class="s-cols-4 m-cols-8 ed-grid rows-gap">
                                                                                    <Divider/>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    ) )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                    }
                                    <Divider/>
                                    </>
                                ) )
                            }
                        </Accordion>
                    ) )
                }
            </div>
            
            <ImageDialog
            isDialogOpened={isOpenImageDialog}
            filtro={filtroImageDialog}
            listaArchivos={archivos_pregunta}
            handleCloseDialog={() => setIsOpenImageDialog(false)}
            tipo="pregunta"
            />
        {/* </SimpleBarReact> */}
        </>
    )
}
